import React, { Component } from 'react'
import { inject, observer } from "mobx-react";
import { Label, Col, Row, FormGroup, Form, Input, Button, Alert } from "reactstrap";
import _ from "lodash";
import ModalForm from "../../comum/components/ModalForm";
import FormInputSimples from "../../comum/components/FormInputSimples";
import { IconeFechar, IconeInformacao, IconeCarregar, Baixar } from "../../comum/components/Icones";
import CheckboxField from '../../comum/components/CheckboxField';
import { splitBR } from "../../../utils/formatar";
import { formatarCNPJ } from '../../../utils/functions';

import FormSelect from '../../comum/components/FormSelect';
import desovaPierService from "../../../services/DesovaPierService";
import { normalizarString } from '../../../utils/functions'
import lscache from 'lscache';
import { Fragment } from 'react';

@inject("store")
@observer
export default class ModalDesovaPierForm extends Component {
    constructor(props) {
        super(props);
        this.controller = this.props.controller;
        this.state = {
            container: '',
            operacoes: [],
            loading: false,
            solicitacao: {
                Id: 0,
                BL: '',
                CE: '',
                Email: '',
                Viagem: '',
                CNPJ: '',
                Observacao: '',
                Razao: '',
                FlagTerno: false,
                Conteineres: [],
                Arquivos: [],
                IdDocumento: 0,
                Status: 0,
            }
        };
    };

    /**
     * Comportamento on Init
     */
    componentDidMount() {
        switch (this.props.modalType) {
            case 'editar':
                this.populateOperations();
                this.controller.configurarModalEditar(this.props.id);
                this.populateSolicitacao(this.props.id);
                break;
            case 'cadastrar':
                this.populateOperations();
                this.controller.configurarModalCadastrar();
                break;
            case 'anexos':
                this.populateOperations();
                this.controller.configurarModalEditarAnexos();
                this.populateSolicitacao(this.props.id);
                break;
            case 'visualizar':
                this.populateOperations();
                this.controller.configurarModalVisualizar(this.props.id);
                this.populateSolicitacao(this.props.id);
                break;
            case 'cancelar':
                this.controller.configurarModalCancelar(() => this.props.closeModal());
                this.setState({ 
                    solicitacao: { Id: this.props.id }
                });
                break;
            default: 
                this.controller.configurarModalFinalizar();
                break;
        }
    };

    populateOperations(){
        desovaPierService.obterOperacoes().then(({ data }) => {
            if (typeof (data) != 'undefined') {
                const operacoes = data.map(x => {
                    return {
                        Id: x.Viagem,
                        Texto: `${x.Viagem} - ${x.Navio}`
                    };
                });
                this.setState({ operacoes });
            }
        }).catch(err => {
            console.log(err)
        });
    }

    populateSolicitacao(id){
        this.setState({loading: true});
        desovaPierService.obterSolicitacao(id)
            .then(response => {
                this.setState({ 
                    solicitacao: {
                        ...response.data, 
                        FlagTerno: response.data.FlagTerno === "S",
                        Observacao: response.data.Observacao || ''
                    } 
                });
            }).catch(error => {
                console.log(error);
            }).finally(()=>{
                this.setState({loading: false});
            })
    }

    /**
     * @returns Mensagem de aviso com icone
     */
    avisoAnexo = () => {
        let mensagem = "Documentos essenciais: BL, Packing list, FISPQ, Ficha de emergência (obrigatório para químico/classificado)";

        return <Col xs={12} sm={12} md={12} lg={8} xl={8} className="d-flex justify-content-center align-items-center">
            <Row className="pb-0">
                <div className="flex-row d-flex align-items-center">
                    <IconeInformacao className={'mr-2 icone-aviso'} />
                    <Label className="mb-0 aviso-form">{mensagem}</Label>
                </div>
            </Row>
        </Col>
    };
    
    /**
     * Function to persist Solicitacao state
     * @param {string} key Solicitacao object key
     * @param {string} newValue 
     * @param {boolean} allowSpecial skip normalizeString
     * @param {boolean} allowSpecial skip removeSpaces
     */
    handleInputChange(key, newValue, allowSpecial, allowSpaces) {
        console.log({key, newValue})
        if (key !== 'Email' && !allowSpecial && typeof(newValue) === 'string') {
            newValue = normalizarString(newValue);
        }
        if(!allowSpaces && typeof(newValue) === 'string'){
            newValue = newValue.replace(' ','');
        }

        if(key === 'BL' && newValue !== '') {
            newValue = newValue.toUpperCase();
            if (!/^[A-Z0-9]*$/.test(newValue)) {
                this.controller.erroBL = 'Utilize apenas números e letras.';
            } else {
                this.controller.erroBL = null;
            }
        }
        if(key === 'CE' && newValue !== '') {
            if (/^[0-9]*$/.test(newValue)) {
                this.controller.erroCE = null;
            } else {
                this.controller.erroCE = 'Utilize apenas números.';
                return
            }
        }
        if(key === 'Viagem' && newValue !== '') {
            this.controller.erroViagem = null;
        }
        if(key === 'FlagTerno' && newValue !== '') {
            this.controller.erroTermo = null;
        }
        this.setState({ solicitacao: { ...this.state.solicitacao, [key]:newValue } })
    }

    /**
     * Set IdDocumento por meio de this.state.solicitacao.BL
     */
    procuraDoc = async () => {
        const { CE, IdDocumento} = await this.controller.carregarNCM(this.state.solicitacao.BL);
        // this.handleInputChange('CE', CE);
        this.handleInputChange('IdDocumento', IdDocumento);
    }

    /**
     * Set Razao Social por meio de this.state.solicitacao.CNPJ
     */
    procuraCNPJ = async () => {
        const formatedCnpj = formatarCNPJ(this.state.solicitacao.CNPJ);
        if (formatedCnpj && formatedCnpj.length !== 18) {
            this.controller.erroCNPJ = "CNPJ incompleto"
            this.handleInputChange('Razao', '');
            return
        }
        this.handleInputChange('CNPJ', formatedCnpj, true);
        const { Razao } = await this.controller.carregarCnpj(formatedCnpj);
        this.handleInputChange('Razao', Razao, true, true);
    }

    /**
     *  Set Containeres com novo container
     */
    adicionarUnidade = () => {
        const newList = this.controller.adicionarUnidade(this.state.container, this.state.solicitacao.Conteineres);
        if (newList) {
            this.handleInputChange('Conteineres', newList)
            this.controller.erroConteiner = null;
            this.setState({ container: '' })
        }
    }

    removerUnidade = async (numero, id, index) => {
        console.log({ id, index })
        if (id != 0) {
            try {
                const response = await desovaPierService.deletarContainer(id);
                if (!response.data) {
                    this.mensagemErro = 'Erro ao apagar. Tente novamente.'
                    console.log(response);
                    return;
                }
            } catch (error) {
                this.controller.mensagemErro = 'Erro ao apagar. Tente novamente.';
                console.log(error);
                return;
            }
        }
        this.handleInputChange('Conteineres', this.state.solicitacao.Conteineres.filter((_, i) => i !== index))
    }

    adicionarAnexos = (e) => {
        const files = this.controller.anexarArquivo(e);
        this.handleInputChange('Arquivos', [...this.state.solicitacao.Arquivos, ...files]);
    }

    baixarAnexo = (id, index) => {
        this.controller.baixarArquivo(this.state.solicitacao.Arquivos, index, id);
    }

    removerAnexo = async (id, index) => {
        if (id !== 0) {
            try {
                const response = await desovaPierService.deletarAnexo(id);
                if (!response.data) {
                    this.mensagemErro = 'Erro ao apagar. Tente novamente.'
                    console.log(response);
                    return;
                }
                this.handleInputChange('Arquivos', this.state.solicitacao.Arquivos.filter((_, i) => i !== index))
            } catch (error) {
                this.controller.mensagemErro = 'Erro ao apagar. Tente novamente.';
                console.log(error);
                return;
            }
        } else {
            this.handleInputChange('Arquivos', this.state.solicitacao.Arquivos.filter((_, i) => i !== index))
        }
    }

    render() {
        return (
            <ModalForm 
                salvando={this.controller.salvando}
                className={`area-form-modal modal-analise ${this.controller.salvarConcluido ? 'carregar' : ''}` }
                classContainer="modal-layer"
                labelConfirmar={<span className="btn-enviar">{this.controller.modalConfig.labelConfirmar}</span>}
                labelCancelar={this.controller.modalConfig.labelCancelar}
                onClickCancelar={() => this.props.closeModal()}
                onClickSalvar={() => this.controller.modalConfig.onClickSalvar(this.state.solicitacao)} 
                habilitaSalvar
            >

                <h2>{this.controller.modalConfig.modalTitulo}</h2>
                <Form>
                    {
                        this.state.loading ? 
                        <IconeCarregar tamanho="2x" /> : 
                        !this.controller.salvarConcluido && this.form()
                    }
                </Form>
                {!this.controller.salvarConcluido && this.mensagemSubmit()}
            </ModalForm>
        )
    };

    // components

    form = () => {
        const isBloqued = this.controller.modalConfig.tipoModal === 'anexos' || this.controller.modalConfig.tipoModal === 'visualizar';
        return (
            <FormGroup>
                <Row className="pb-0">
                    {
                        this.controller.erroValidacao &&
                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Alert color="danger">
                                {this.controller.erroValidacao}
                            </Alert>
                        </Col>
                    }
    
                    <FormInputSimples titulo="MBL" xs={12} sm={12} md={6} lg={6} xl={6}
                        obrigatorio
                        value={this.state.solicitacao.BL}
                        alerta={this.controller.erroBL}
                        limiteMaximo={255}
                        onChange={({target: {value}}) => this.handleInputChange('BL', value)}
                        bloqueado={isBloqued}
                        onEnter={this.procuraDoc}
                        onBlur={this.procuraDoc} 
                    />
    
                    <FormInputSimples titulo="CE MBL" xs={12} sm={12} md={6} lg={6} xl={6}
                        limiteMaximo={15}
                        obrigatorio
                        value={this.state.solicitacao.CE}
                        alerta={this.controller.erroCE}
                        onChange={({target: {value}}) => this.handleInputChange('CE', value)}
                        bloqueado={isBloqued}
                    />
    
                    <FormSelect
                        obrigatorio
                        titulo="Operação" sm={12} md={6} lg={6} xl={6}
                        itens={this.state.operacoes}
                        objeto={this.state.solicitacao}
                        dado={'Viagem'}
                        itensValor="Id" itensLabel="Texto"
                        alerta={this.controller.erroViagem}
                        value={this.state.solicitacao.Viagem}
                        onChange={(event) => this.handleInputChange('Viagem', event ? event.value : '')}
                        bloqueado={isBloqued}
                    />
    
                    <FormInputSimples titulo="E-mail" xs={12} sm={12} md={6} lg={6} xl={6}
                        obrigatorio
                        alerta={this.controller.erroEmail}
                        limiteMaximo={100}
                        value={this.state.solicitacao.Email}
                        onChange={({target: {value}}) => this.handleInputChange('Email', value)}
                        bloqueado={isBloqued}
                    />
    
                    <FormInputSimples titulo="Cobrar de (CNPJ)" xs={12} sm={12} md={6} lg={4} xl={4}
                        obrigatorio
                        alerta={this.controller.erroCNPJ}
                        limiteMaximo={30}
                        value={this.state.solicitacao.CNPJ}
                        onChange={({target: {value}}) => this.handleInputChange('CNPJ', value)}
                        onEnter={this.procuraCNPJ}
                        onBlur={this.procuraCNPJ} 
                        bloqueado={isBloqued}
                    />
    
                    {this.controller.carregandoRazao ?
                        <IconeCarregar tamanho="2x"/> :
                        <FormInputSimples titulo="Razão social" xs={12} sm={12} md={6} lg={8} xl={8}
                            bloqueado={true}
                            value={this.state.solicitacao.Razao}
                        />
                    } 
                </Row>
                <Row className={'px-3'}>
                    <Col xs={12} sm={12} md={6} lg={4} xl={4}>
                        <CheckboxField 
                            key='FlgTermo'
                            sm={12} md={6} lg={6}
                            text='Termo de Anuência'
                            obrigatorio
                            alerta={this.controller.erroTermo}
                            onClick={() => null}
                            ativo={this.state.solicitacao.FlagTerno}
                            onChange={checked => this.handleInputChange('FlagTerno', checked)}
                            showRequiredLabel
                            bloqueado={isBloqued}
                        />
                    </Col>
                    {this.textoTermo()}
                </Row>
    
                {this.campoConteiner()}
    
                <Row>
                    {this.campoAnexo()}
    
                    <FormInputSimples titulo="Observações" xs={12} sm={12} md={12} lg={12} xl={12}
                        value={this.state.solicitacao.Observacao}
                        alerta={''}
                        type="textarea"
                        limiteMaximo={2000}
                        onChange={({target: {value}}) => this.handleInputChange('Observacao', value, true, true)}
                        bloqueado={isBloqued}
                    />
                </Row>
            </FormGroup>
        )
    }

    textoTermo = () => {
        let mensagem = "Isentamos o terminal de qualquer responsabilidade sobre divergências, faltas ou avarias no momento da abertura do container.";

        return <Col xs={12} sm={12} md={12} lg={8} xl={8} className="d-flex justify-content-center align-items-center">
            <Row className="pb-0">
                <div className="flex-row d-flex align-items-center">
                    <IconeInformacao className={'mr-2 icone-aviso'} />
                    <Label className="mb-0 aviso-form">{mensagem}</Label>
                </div>
            </Row>
        </Col>
    };

    campoConteiner = () => {
        const isBloqued = this.controller.modalConfig.tipoModal === 'anexos' || this.controller.modalConfig.tipoModal === 'visualizar';
        return <div>
            <Row className={'pb-0'}>
                <FormInputSimples 
                    titulo="Conteineres"
                    xs={6} sm={6} md={10} lg={10} xl={10}
                    value={this.state.container}
                    onEnter={this.adicionarUnidade}
                    onBlur={() => document.getElementById('addButton').focus()}
                    onChange={({target: {value: container}}) => this.setState({ container })}
                    showRequiredLabel
                    bloqueado={isBloqued}
                />

                <Col xs={6} sm={6} md={2} lg={2} xl={2}>
                    <Button 
                        id="addButton"
                        onClick={this.adicionarUnidade}
                        style={{ marginTop: '27px' }} 
                        className="btn-com-bordas-primary"
                        disabled={isBloqued}
                    >
                        Add
                    </Button>
                </Col>
            </Row>
            {this.controller.erroConteiner && <Col><Label className="label-danger mensagem">{this.controller.erroConteiner}</Label></Col>}
            <Row className={'pb-0'}>
                {this.state.solicitacao.Conteineres.length > 0 &&
                    <Col xs={12} md={12} className="mb-4">{
                        this.state.solicitacao.Conteineres.map((item, index) =>
                            <div key={index} className={`item-anexo`}>
                                <span>{`${item.Numero}`}</span>
                                {this.controller.modalConfig.tipoModal !== 'anexos' && this.controller.modalConfig.tipoModal !== 'visualizar' &&
                                    <span>
                                        <IconeFechar 
                                            tamanho="lg" 
                                            onClick={() => this.removerUnidade(item.Numero, item.Id, index)} 
                                        />
                                    </span>
                                }
                            </div>
                        )}
                    </Col>
                }
            </Row>
        </div>
    };

    campoAnexo = () => {
        const internoExterno = lscache.get('InternoExterno');
        const alerta = this.controller.mensagemAnexo;
        const isBloqued = this.controller.modalConfig.tipoModal === 'visualizar';


        return <Row className={'px-3'}>
            <Col xs={12} sm={12} md={6} lg={4} xl={4}>
                <Label>Anexos</Label>
                <Input 
                    className="p-2 mb-4" 
                    type="file" 
                    onChange={e => this.adicionarAnexos(e)} 
                    accept=".csv, .xml, .txt, .xls, .xlsx, .doc, .pdf" 
                    multiple
                    disabled={isBloqued}
                />
                { (alerta && alerta.length > 0) && <Label className="label-primary">{ alerta }</Label> }
            </Col>
            {this.avisoAnexo()}
            {this.state.solicitacao.Arquivos.length > 0 &&
                <Col xs={12} md={12} className="mb-4">{
                    this.state.solicitacao.Arquivos.map((item, index) =>
                        <div key={index} className={`item-anexo`}>
                            <span>{`${item.Nome}.${item.Extensao}`}</span>
                            <span>
                                {(internoExterno === 'I' || item.PermiteDownload || item.Id === 0) &&
                                    <Fragment>
                                        <Baixar tamanho="lg" className="mr-2" cor="#001c43" onClick={() => this.baixarAnexo(item.Id, index)} />
                                        {this.controller.modalConfig.tipoModal !== 'visualizar' && 
                                            <IconeFechar tamanho="lg" onClick={() => this.removerAnexo(item.Id, index)} />
                                        }
                                    </Fragment>
                                }
                            </span>
                        </div>
                    )}
                </Col>
            }
        </Row>
    };

    mensagemSubmit = () => {
        if (this.controller.mensagemErro) {
            console.log(this.controller.mensagemErro)
            return <Col className='mb-0 pr-0 text-right col label-danger'>{splitBR(this.controller.mensagemErro)}</Col>
        }
        if (this.controller.mensagemSucesso) {
            console.log(this.controller.mensagemSucesso)
            return <Col className='mb-0 pr-0 text-right col label-primary'>{splitBR(this.controller.mensagemSucesso)}</Col>
        }
    };
    // end components
}



// WEBPACK FOOTER //
// ./src/modules/desova-pier/components/ModalDesovaPierForm.js